<template>
  <div v-loading="initLoading">
    <div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa">
      <div style="font-size: 20px">
        <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
          <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/ReportDetailPagePurchase' }">业务员账号替身登录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="font-size: 25px;margin-top: 15px;">
        <p>业务员账号替身登录</p>
      </div>
      <div style="width: 100%; font-size: 25px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
                 style="margin-top: 10px;width: 500px">
          <el-form-item label="供应商" prop="supplier">
            <el-select v-model="ruleForm.supplier" @change="supplierChange" filterable remote placeholder="请选择供应商"
            style="width: 400px" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in suppliers"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 15px">{{item.id}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导购员账户" prop="sale">
            <el-select v-model="ruleForm.sale" filterable remote clearable placeholder="请选择导购员账户"
                       style="width: 400px" :loading="loadingSale" @change="saleChange"
                       :remote-method="findSale" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in sales"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 20px">{{item.id}}</span>
              </el-option>
            </el-select>
            <div class="descriptions" v-if="employeeLoginStatus">在代登录期间，业务员将无法正常登录小程序。</div>
          </el-form-item>
          <el-form-item label="业务员账户" prop="manager">
            <el-select v-model="ruleForm.manager" ref="manager" filterable remote clearable placeholder="请选择业务员账户"
                       style="width: 400px" :loading="loadingManager"
                       :remote-method="findManager" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in managers"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 20px">{{item.phoneNumber}}</span>
              </el-option>
            </el-select>
            <div class="descriptions" v-if="employeeLoginStatus">在代登录期间，业务员将无法正常登录小程序。</div>
          </el-form-item>

          <el-form-item label="管理员账号" prop="employee">
            <el-select v-model="ruleForm.employee" filterable clearable placeholder="请选择管理员账号"
                       style="width: 400px" :disabled="employeeLoginStatus">
              <el-option
                v-for="item in employees"
                :key="item.id"
                :label="item.name"
                :value='item.id'>
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right;padding-right:16px; color: #8492a6; font-size: 20px">{{
                    item.id
                  }}</span
                >
              </el-option>
            </el-select>
            <div class="descriptions" v-if="employeeLoginStatus">管理员可打开通路管理助手，替身登录业务员账户。</div>
          </el-form-item>

          <el-form-item>
            <el-button v-if="employeeLoginStatus" class="button" @click="cancelEmployeeLoginInfo">断开</el-button>
            <el-button v-else class="button" @click="submitForm('ruleForm')">登入</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

import {confirmEmployeeLoginInfo} from "@/api/LoginSaleAccount";
import {queryManagers, querySuppliers,querySales,cancelManagerEmployeeLoginInfo} from "@/api/LoginManagerAccount";

export default {
  name: 'LoginManagerAccount',
  data() {
    return {
      ruleForm: {
        supplier: '',
        manager: '',
        sale: '',
        employee: ''
      },
      rules: {
        supplier: [
          {required: true, message: '请选择供应商。', trigger: 'change'}
        ],
        manager: [
          {required: true, message: '请选择业务员账户。', trigger: 'change'}
        ],
        employee: [
          {required: true, message: '请选择管理员账号', trigger: 'change'}
        ]
      },
      token: '',
      loading: false,
      initLoading: true,
      sales: [],
      employees: [],
      employeeLoginStatus: false,
      source: null,
      loadingSale: false,
      loadingManager: false,
      suppliers: [],
      managers: []
    }
  },
  mounted() {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId === '15900973961' || supplierId === '17898848378') {
      this.token = localStorage.getItem('token')
      this.initPageData();
    } else {
      this.$router.replace({ path: '/Console' })
    }
  },
  methods: {
    //加载页面数据
    initPageData() {
      this.initLoading = true;
      querySuppliers(this.token).then(res => {
        if (res.data.code === 200) {
          this.suppliers = res.data.data.suppliers
          if (this.suppliers.length === 1) {
            this.ruleForm.supplier = this.suppliers[0]
          }
          this.employees = res.data.data.employees;
          this.employeeLoginStatus = res.data.data.employeeLoginStatus;
          if (this.employeeLoginStatus) {
            this.ruleForm.manager = res.data.data.manager;
            this.ruleForm.employee = res.data.data.employee;
            this.managers = res.data.data.managers
          }
        }
      }).catch(error => {
        let status = error.response.status;
        if (status === 500) {
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.initLoading = false);
    },
    findManager(manager) {
      if (manager !== '' && this.ruleForm.supplier !== '') {
        const data = {supplier:this.ruleForm.supplier,manager: manager}
        this.loadingManager = true
        queryManagers(this.token,data).then(res => {
          if (res.data.code === 200) {
            this.managers = res.data.data
          }
        }).finally(() => this.loadingManager = false)
      }
    },
    supplierChange() {
      this.sales = []
      if (this.ruleForm.supplier !== '') {
        this.loadingManager = true
        queryManagers(this.token,{supplier:this.ruleForm.supplier}).then(res => {
          if (res.data.code === 200) {
            this.managers = res.data.data
            if (res.data.data.length > 0) {
              this.$refs.manager.focus()
            }
          }
        }).finally(() => this.loadingManager = false)
      } else {
        this.managers = []
      }
    },
    saleChange() {
      if (this.ruleForm.sale !== '') {
        this.loadingManager = true
        queryManagers(this.token,{supplier:this.ruleForm.supplier,sale:this.ruleForm.sale}).then(res => {
          if (res.data.code === 200) {
            this.managers = res.data.data
            if (res.data.data.length > 0) {
              this.$refs.manager.focus()
            }
          }
        }).finally(() => this.loadingManager = false)
      }
    },
    findSale(item) {
      if (item !== '' && this.ruleForm.supplier !== '') {
        this.loadingSale = true
        querySales(this.token, {supplier:this.ruleForm.supplier,param:item}).then(res => {
          if (res.data.code === 200) {
            this.sales = res.data.data;
          }
        }).finally(() => this.loadingSale = false)
      }
    },
    rollback() {
      this.sales = this.salesBak;
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.manager === this.ruleForm.employee) {
            return this.$notify.error({
              title: '错误',
              message: '不可登入自己的通路管理账户',
              position: 'bottom-right'
            })
          }

          this.initLoading = true;
          const data = {manager:this.ruleForm.manager,employee:this.ruleForm.employee}
          confirmEmployeeLoginInfo(this.token,data).then(res => {
            if (res.data.code === 200) {
              this.employeeLoginStatus = true;
              this.$notify.success({
                title: '成功',
                message: '登入成功',
                position: 'bottom-right'
              })
            }
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '登入失败',
              position: 'bottom-right'
            })
          }).finally(() => {
            this.initLoading = false;
          })
        } else {
          return false;
        }
      });
    },
    cancelEmployeeLoginInfo() {
      this.initLoading = true;
      cancelManagerEmployeeLoginInfo(this.token).then(res => {
        if (res.data.code === 200) {
          this.employeeLoginStatus = false;
          this.$notify.success({
            title: '成功',
            message: '断开成功',
            position: 'bottom-right'
          })
        }
      }).catch(() => {
        this.$notify.error({
          title: '失败',
          message: '登入失败',
          position: 'bottom-right'
        })
      }).finally(() => {
        this.initLoading = false;
      })
    }
  }
}
</script>

<style scoped>
.el-select .el-input.is-focus .el-input__inner {
  border-color: #EF6C00;
}

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  color: #EF6C00
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.descriptions {
  line-height: 25px;
  font-size: 10px;
  color: #ED7043;
}

.button {
  color: white !important;
  background: #ff6633 !important;
}
</style>
